import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
/* actions */
import { getAllCodesNCM, editCodesNCM } from '../../redux/actions/codesNCM';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/codeNCM';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';
import handleChangeCurrency from '../../utils/handleChangeCurrency';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    _id: id || '',
    code: '',
    description: '',
    nacionalAliquot: '0,00',
    importationAliquot: '0,00',
    exTIPI: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema
  });
  const codesNCM = useSelector(state => state.codesNCM);
  const codeNCM = codesNCM.data.find(item => item._id === id);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    dispatch(getAllCodesNCM());
  }, [dispatch]);

  useEffect(() => {
    if (codeNCM) {
      const newData = {
        ...codeNCM,
        nacionalAliquot: String(codeNCM.nacionalAliquot.toFixed(2)).replace(
          /\./g,
          ','
        ),
        importationAliquot: String(
          codeNCM.importationAliquot.toFixed(2)
        ).replace(/\./g, ',')
      };
      setData(newData);
    }
  }, [codeNCM]);

  const submit = () => {
    const newData = {
      ...data,
      nacionalAliquot: parseFloat(data.nacionalAliquot.replace(/,/g, '.')),
      importationAliquot: parseFloat(data.importationAliquot.replace(/,/g, '.'))
    };
    dispatch(editCodesNCM(newData, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {codesNCM.editSuccess && (
        <AlertMsg type="success" msg="Código NCM atualizado com sucesso" />
      )}
      {codesNCM.errorContent &&
        !codesNCM.errorContent.message.includes('400') &&
        codesNCM.editError && (
        <AlertMsg
          type="danger"
          msg="Falha durante atualização do código NCM"
        />
      )}
      {codesNCM.errorContent &&
        codesNCM.errorContent.message.includes('400') &&
        codesNCM.editError && (
        <AlertMsg
          type="danger"
          msg="Um NCM com o código informado já está cadastrado"
        />
      )}
      {!codesNCM.editSuccess && !codesNCM.editError && (
        <AlertMsg type="info" msg="Área atualização de códigos NCM" />
      )}
      <FormHeader title="Atualizar Código NCM" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="code">Código</label>
              <InputMask
                id="code"
                name="code"
                mask="9999.99.99"
                className="form-control"
                autoComplete="off"
                placeholder="____.__.__"
                value={data.code}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.code && errors.code.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.code && errors.code.type === 'ncm' && (
                <ErrorMsgField type="ncm" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="nacionalAliquot">Alíquota Nacional</label>
              <input
                type="text"
                className="form-control"
                id="nacionalAliquot"
                name="nacionalAliquot"
                number="on"
                value={data.nacionalAliquot}
                autoComplete="off"
                onChange={evt => handleChangeCurrency(evt, data, setData)}
                ref={register}
              />
              {errors.nacionalAliquot &&
                errors.nacionalAliquot.type === 'currency' && (
                <ErrorMsgField type="currency" />
              )}
              {errors.nacionalAliquot &&
                errors.nacionalAliquot.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.nacionalAliquot &&
                errors.nacionalAliquot.type === 'min' && (
                <ErrorMsgField type="min" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="importationAliquot">Alíquota Importação</label>
              <input
                type="text"
                className="form-control"
                id="importationAliquot"
                name="importationAliquot"
                number="on"
                value={data.importationAliquot}
                autoComplete="off"
                onChange={evt => handleChangeCurrency(evt, data, setData)}
                ref={register}
              />
              {errors.importationAliquot &&
                errors.importationAliquot.type === 'currency' && (
                <ErrorMsgField type="currency" />
              )}
              {errors.importationAliquot &&
                errors.importationAliquot.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.importationAliquot &&
                errors.importationAliquot.type === 'min' && (
                <ErrorMsgField type="min" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="exTIPI">EX-TIPI</label>
              <input
                type="text"
                className="form-control"
                id="exTIPI"
                name="exTIPI"
                autoComplete="off"
                defaultValue={data.exTIPI}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.exTIPI && errors.exTIPI.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="description">Descrição</label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            defaultValue={data.description}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/codes_ncm" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
